function formatComment(text) {
    return text
        .replace(/\\/g, '\\\\')   // екрануємо зворотні слеші
        .replace(/"/g, '\\"')     // екрануємо подвійні лапки
        .replace(/\n/g, '\\n')    // замінюємо новий рядок на \n
        .replace(/\t/g, '\\t');   // замінюємо табуляцію на \t
}

function formatColumnName(colName) {
    // Зарезервовані слова SQL Server (T-SQL)
    const reserved = new Set([
        'add', 'all', 'alter', 'and', 'any', 'as', 'asc', 'authorization',
        'backup', 'begin', 'between', 'break', 'browse', 'bulk', 'by', 'cascade',
        'case', 'check', 'checkpoint', 'close', 'clustered', 'coalesce', 'collate',
        'column', 'commit', 'compute', 'constraint', 'contains', 'containstable',
        'continue', 'convert', 'create', 'cross', 'current', 'current_date',
        'current_time', 'current_timestamp', 'current_user', 'cursor', 'database',
        'dbcc', 'deallocate', 'declare', 'default', 'delete', 'deny', 'desc',
        'disk', 'distinct', 'distributed', 'double', 'drop', 'dump', 'else',
        'end', 'errlvl', 'escape', 'except', 'exec', 'execute', 'exists',
        'exit', 'external', 'fetch', 'file', 'fillfactor', 'for', 'foreign',
        'freetext', 'freetexttable', 'from', 'full', 'function', 'goto', 'grant',
        'group', 'having', 'holdlock', 'identity', 'identity_insert',
        'identitycol', 'if', 'in', 'index', 'inner', 'insert', 'intersect',
        'into', 'is', 'join', 'key', 'kill', 'left', 'like', 'lineno', 'load',
        'merge', 'national', 'nocheck', 'nonclustered', 'not', 'null', 'nullif',
        'of', 'off', 'offsets', 'on', 'open', 'opendatasource', 'openquery',
        'openrowset', 'openxml', 'option', 'or', 'order', 'outer', 'over',
        'percent', 'pivot', 'plan', 'precision', 'primary', 'print', 'proc',
        'procedure', 'public', 'raiserror', 'read', 'readtext', 'reconfigure',
        'references', 'replication', 'restore', 'restrict', 'return', 'revert',
        'revoke', 'right', 'rollback', 'rowcount', 'rowguidcol', 'rule',
        'save', 'schema', 'securityaudit', 'select', 'session_user', 'set',
        'setuser', 'shutdown', 'some', 'statistics', 'system_user', 'table',
        'tablesample', 'textsize', 'then', 'to', 'top', 'tran', 'transaction',
        'trigger', 'truncate', 'tsequal', 'union', 'unique', 'unpivot', 'update',
        'updatetext', 'use', 'user', 'values', 'varying', 'view', 'waitfor',
        'when', 'where', 'while', 'with', 'writetext'
    ]);

    // Перевірки
    const hasSpecialChars = /[^a-zA-Z0-9_]/.test(colName);  // пробіли або спецсимволи
    const startsWithNumber = /^[0-9]/.test(colName);        // починається з цифри
    const isReserved = reserved.has(colName.toLowerCase()); // зарезервоване слово

    // Якщо є спецсимволи, цифра на початку або зарезервоване слово — беремо в квадратні дужки
    if (hasSpecialChars || startsWithNumber || isReserved) {
        return `[${colName}]`;
    }

    return colName;
}

function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');

    // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * Генерує SQL код для створення таблиць SQL Server на основі заданого об'єкта.
 * @param {Object} tables - Об'єкт, що описує таблиці та колонки.
 * Структура об'єкту:
 * {
 *      "table_id": {
 *          "id": "table_id",
 *          "value": {
 *              "header": {
 *                  "name": "table_name",
 *              },
*               "columns": {
*                   "column_id": {
*                       "id": "column_id",
*                       "name": "column_name",
*                       "type": "VARCHAR(255)",
*                       "isPK": false,
*                       "isFK": false,
*                       "isAutoIncrement": false,
*                       "isNN": false,
*                       "enumValues": null,
*                       "defaultValue": null,
*                       "checkValue": null,
*                       "generatedValue": null,
*
*                       "isGeneratedValueVirtual": false,
*                       "isGeneratedValueStored": false,
*                       "onUpdate": null,
*
*                       "fkRefTable": null,
*                       "fkRefColumn": null,
*                       "index": {
*                         "compositeColumns": null,
*                         "isRegular": false,
*                         "isUnique": false,
*                         "isComposite": false,
*                         "isFullText": false,
*                         "indexName": null
*                       }
*                   }
*               }
*           }
*       }
*  }
* @param {string} projectName - Ім'я проєкту (для преамбули).
* @param {string} projectVersion - Версія проєкту (для преамбули).
* @param {string} sqlServerVersion - Цільова версія SQL Server
* @returns {string} SQL код для створення всіх таблиць.
*/
export default function generateCode(
    tables,
    projectName = 'Core Service',
    // projectVersion = '1.4.43',
    // sqlServerVersion = '2022' // '2019', '2017', '2016'
) {
    const exportDate = formatDate(new Date());
    const serviceName = 'dbdesign.io';

    const statements = [];
    const enumsStatements = [];
    const tablesStatements = [];

    const enumsDefinitionsByTables = {};
    const commentsDefinitionsByTables = {};
    const indexesDefinitionsByTables = {};
    const foreignKeysDefinitionsByTables = {};

    // -- ----------------------------------------------
    // -- Project Name: --------- Core Service ---------
    // -- Database: ------------- SQL Server -----------
    // -- Export Date: ---------- 2024-12-21 22:10:15 --
    // -- Created By: ----------- dbdesign.io ----------
    // -- ----------------------------------------------
    // -- Project Version: ------ 1.4.43 ---------------

    const preambulaName = `Project Name: --------- ${projectName}`;
    // const preambulaVersion = `Project Version: ------ ${projectVersion}`;
    const preambulaDB = `Database: ------------- SQL Server`;
    const preambulaDate = `Export Date: ---------- ${exportDate}`;
    const preambulaCreatedBy = `Created By: ----------- ${serviceName}`;

    const preambulaLength = Math.max(
        preambulaName.length,
        // preambulaVersion.length,
        preambulaDB.length,
        preambulaDate.length,
        preambulaCreatedBy.length
    ) + 3;

    let preambulaStatement = '';
    preambulaStatement += `-- ${'-'.repeat(preambulaLength)}`;
    preambulaStatement += `\n-- ${preambulaName} ${'-'.repeat(preambulaLength - preambulaName.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaDB} ${'-'.repeat(preambulaLength - preambulaDB.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaDate} ${'-'.repeat(preambulaLength - preambulaDate.length - 1)}`;
    preambulaStatement += `\n-- ${preambulaCreatedBy} ${'-'.repeat(preambulaLength - preambulaCreatedBy.length - 1)}`;
    preambulaStatement += `\n-- ${'-'.repeat(preambulaLength)}`;

    statements.push(preambulaStatement);

    const goCode = '\nGO';

    // ------------ SET TABLE NAME MAX LENGTH ------------
    let tableNameMaxLength = 0;
    for (const tableKey in tables) {
        const table = tables[tableKey];
        let tableName = formatColumnName(table?.value?.header?.name || '');

        if (tableName.length > tableNameMaxLength) {
            tableNameMaxLength = tableName.length;
        }
    }

    // ------------ TABLES ------------
    for (const tableKey in tables) {
        const table = tables[tableKey];
        const { value: { header: { name: tableName }, columns, description: tableDescription } } = table;

        // before 'create table' statements

        const enums = [];
        const enumsDefinitions = [];

        // inside 'create table' statements

        const columnsDefinitions = [];

        const primaryKeys = [];
        const primaryKeysDefinitions = [];

        const uniqueIndexes = [];
        const uniqueDefinitions = [];

        const checks = [];
        const checksDefinitions = [];

        // after 'create table' statements

        const indexes = [];
        const indexesDefinitions = [];

        const foreignKeys = [];
        const foreignKeysDefinitions = [];

        const comments = [];
        const commentsDefinitions = [];

        // SET COLUMN NAME MAX LENGTH
        let colNameMaxLength = 0;
        for (const columnKey in columns) {
            const col = columns[columnKey];

            let colName = formatColumnName(col.name);
            if (colName.length > colNameMaxLength) {
                colNameMaxLength = colName.length;
            }
        }

        // ------------ COLUMNS START ------------
        for (const columnKey in columns) {
            const col = columns[columnKey];

            const isColumnAutoIncrement = col.isAutoIncrement;
            const isColumnEnum = col.enumValues && Array.isArray(col.enumValues) && col.enumValues.length > 0; // && col.type === 'enum'
            const isColumnGenerated = col.generatedValue;
            const hasColumnDefault = col.defaultValue !== null && col.defaultValue !== undefined;
            const hasColumnCheck = col.checkValue;

            let colDef = '';

            // ------ COLUMN NAME ------
            const colName = formatColumnName(col.name);
            const spacesCount = colNameMaxLength - colName.length + 3;

            colDef += `${colName}${' '.repeat(spacesCount)}`;

            // ------ COLUMN TYPE ------
            if (!isColumnEnum && !isColumnGenerated) {
                colDef += `${col.type}`;
            }

            // ------ ADD TO ENUMS ------
            if (isColumnEnum) {
                const enumName = col.enumName || `enm_${tableName}_${col.name}`;

                enums.push({
                    tableName: tableName,
                    columnName: col.name,
                    enumName,
                    enumValuesString: col.enumValues.map(v => `'${v}'`).join(', '),
                });
            }

            // ------ GENERATED VALUE ------
            // ------ " AS (expression) [[PERSISTED]]"
            if (isColumnGenerated) {
                colDef += `AS (${col.generatedValue})`;

                // ------ PERSISTED ------
                if (col.isGeneratedValueStored) {
                    colDef += ` PERSISTED`;
                }
            } else {
                // ------ AUTO_INCREMENT ------
                // ------ ` IDENTITY(1, 1)`
                if (col.isAutoIncrement) {
                    colDef += ` IDENTITY(1, 1)`;
                }

                // ------ NOT NULL ------
                // ------ " NOT NULL"
                if (col.isNN) {
                    colDef += ` NOT NULL`;
                }

                // ------ DEFAULT VALUE ------
                // ------ " DEFAULT 'default_string'"
                // ------ " DEFAULT default_number"
                if (hasColumnDefault) {
                    // ------ STRING ------
                    if (typeof col.defaultValue === 'string') {
                        if (['CURRENT_TIMESTAMP', 'NULL'].includes(col.defaultValue.toUpperCase())) {
                            colDef += ` DEFAULT ${col.defaultValue}`;
                        } else {
                            colDef += ` DEFAULT '${col.defaultValue}'`;
                        }
                    } else if (typeof col.defaultValue === 'number') {
                        // ------ NUMBER ------
                        colDef += ` DEFAULT ${col.defaultValue}`;
                    } else {
                        // nothing;
                    }
                }

                // ------ ADD TO CHECKS (SINGLE COLUMN) ------
                if (col.checkValue) {
                    checks.push({
                        columnNames: [col.name],
                        checkName: col.checkName,
                        checkValue: col.checkValue,
                    });
                }
            }

            // ------ ADD TO PRIMARY KEYS ------
            if (col.isPK) {
                primaryKeys.push(col.name);
            }

            // ------ ADD TO FOREIGN KEYS ------
            if (col.isFK && col.fkRefTable && col.fkRefColumn) {
                foreignKeys.push({
                    tableName: tableName,
                    columnNames: [col.name],

                    refTableName: col.fkRefTable,
                    refColumnNames: [col.fkRefColumn],

                    onUpdateTrigger: col.onUpdateTrigger,
                    onDeleteTrigger: col.onDeleteTrigger,
                });
            }

            // ------ ADD TO INDEXES ------
            if (col.index) {
                const idx = col.index;
                // index = { isRegular, isUnique, isFullText, isComposite, indexName, compositeColumns }

                // ------ UNIQUE ------
                // if (idx.isUnique) {
                if (idx.type === 'unique') {
                    uniqueIndexes.push({
                        columnNames: [col.name],
                        type: 'unique',
                    });

                    // ------ FULLTEXT ------
                    // } else if (idx.isFullText) {
                } else if (idx.type === 'fullText') {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'fullText',
                    });

                    // ------ SPATIAL ------
                    // } else if (idx.isSpatial) {
                } else if (idx.type === 'spatial') {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'spatial',
                    });

                    // ------ REGULAR ------
                    // } else if (idx.isRegular) {
                } else {
                    indexes.push({
                        tableName: tableName,
                        columnNames: [col.name],
                        type: 'regular',
                    });
                }
            }

            // ------ ADD TO COMMENTS ------
            if (col.description) {
                comments.push({
                    tableName: tableName,
                    columnName: col.name,
                    description: col.description,
                });
            }

            columnsDefinitions.push(colDef);
        }
        // ------------ COLUMNS END ------------

        // ------------ PRIMARY KEY ------------
        // ------------ `CONSTRAINT [key_name] PRIMARY KEY ([column1], [column2])`
        if (primaryKeys.length > 0) {
            const pkName = formatColumnName(`pk_${tableName}`);
            const pkDefinition = `CONSTRAINT ${pkName} PRIMARY KEY (${primaryKeys.map(c => formatColumnName(c)).join(', ')})`;

            primaryKeysDefinitions.push(pkDefinition);
        }

        // ------------ UNIQUE INDEX ------------
        // ------------ `CONSTRAINT [table1_col1_col2_uq_idx] UNIQUE ([column1], [column2])`
        uniqueIndexes.forEach((idx, i) => {
            const columnNames = idx.columnNames || [];
            const columnNamesFormated = columnNames.map(column => formatColumnName(column)).join(', ');

            const indexName = idx.indexName || `${tableName}_${columnNames.join('_')}_uq_idx`;
            let indexDefinition = `CONSTRAINT ${formatColumnName(indexName)} UNIQUE (${columnNamesFormated})`;

            uniqueDefinitions.push(indexDefinition);
        });

        // ------------ CHECK ------------
        // ------------ `CONSTRAINT [check_name] CHECK (check_expression)`
        if (checks.length) {
            checks.forEach((chk, i) => {
                const checkName = chk.checkName || `chk_${chk.columnNames.join('_')}`;
                checksDefinitions.push(`CONSTRAINT ${formatColumnName(checkName)} CHECK (${chk.value})`);

            });
        }

        // ------------ FOREIGN KEYS ------------
        // ------------ ALTER TABLE [table1] ADD CONSTRAINT [fk_name] FOREIGN KEY ([col1], [col2]) REFERENCES [table2] ([col1], [col2]) ON UPDATE CASCADE ON DELETE CASCADE;
        // ON DELETE CASCADE, SET NULL, RESTRICT, NO ACTION
        if (foreignKeys.length) {
            for (const fk of foreignKeys) {
                const tableName = fk.tableName;
                const columnNames = fk.columnNames || [];
                const columnNamesFormated = columnNames.map(column => formatColumnName(column)).join(', ');

                const refTableName = fk.refTableName;
                const refColumnNames = fk.refColumnNames || [];
                const refColumnNamesFormated = refColumnNames.map(column => formatColumnName(column)).join(', ');

                const onUpdateTrigger = fk.onUpdateTrigger;
                const onDeleteTrigger = fk.onDeleteTrigger;

                const fkName = fk.fkName || `fk_${tableName}_${columnNames.join('_')}`;

                const spacesCount = tableNameMaxLength - tableName.length;

                let foreignKeyDef = '';
                foreignKeyDef += `ALTER TABLE ${formatColumnName(tableName)}${' '.repeat(spacesCount)} ADD CONSTRAINT ${formatColumnName(fkName)} FOREIGN KEY (${columnNamesFormated}) REFERENCES ${formatColumnName(refTableName)} (${refColumnNamesFormated})`;

                if (onUpdateTrigger) {
                    foreignKeyDef += ` ON UPDATE ${onUpdateTrigger}`;
                }
                if (onDeleteTrigger) {
                    foreignKeyDef += ` ON DELETE ${onDeleteTrigger}`;
                }

                foreignKeyDef += `;`;

                foreignKeyDef += `${goCode}`;

                foreignKeysDefinitions.push(foreignKeyDef);
            }

            foreignKeysDefinitionsByTables[tableName] = foreignKeysDefinitions;
        }

        // ------------ INDEX ------------
        // ------------ CREATE [[UNIQUE | CLUSTERED | NONCLUSTERED]] INDEX [index_name]
        // ON [schema_name.]table_name (column_name [ASC | DESC], ...)
        // [WITH (FILLFACTOR = fillfactor, PAD_INDEX = { ON | OFF }, SORT_IN_TEMPDB = { ON | OFF },
        //        STATISTICS_NORECOMPUTE = { ON | OFF }, ONLINE = { ON | OFF })]
        // [ON { partition_scheme_name (partition_column) | filegroup_name | PRIMARY }];

        if (indexes.length) {
            indexes.forEach((idx, i) => {
                const tableName = idx.tableName;
                const columnNames = idx.columnNames || [];
                const columnNamesFormated = columnNames.map(column => formatColumnName(column)).join(', ');

                let indexType = '';
                let indexTypeShort = '';

                // if (idx.type === 'unique') {
                //     indexType = 'UNIQUE';
                //     indexTypeShort = 'uq';
                // } else if (idx.type === 'fullText') {
                //     indexType = 'FULLTEXT';
                //     indexTypeShort = 'txt';
                // } else if (idx.type === 'spatial') {
                //     indexType = 'SPATIAL';
                //     indexTypeShort = 'sptl';
                // } else if (idx.type === 'regular') {
                //     // REGULAR
                //     // nothing.
                // } else {
                //     // REGULAR
                //     // nothing.
                // }

                const indexName = idx.indexName || `${tableName}_${columnNames.join('_')}_${indexTypeShort ? indexTypeShort + '_' : ''}idx`;
                let indexDefinition = `CREATE INDEX ${formatColumnName(indexName)} ON ${formatColumnName(tableName)} (${columnNamesFormated});`;

                indexDefinition += `${goCode}`;
                indexDefinition += `\n`;

                indexesDefinitions.push(indexDefinition);
            });

            indexesDefinitionsByTables[tableName] = indexesDefinitions;
        }

        // ------------ COMMENTS: TABLE ------------
        // EXEC sp_addextendedproperty
        // @name = N'Table_Description',
        // @value = 'new table comment',
        // @level0type = N'Schema', @level0name = 'scheme_name', -- by default scheme = 'dbo' (Database Owner)
        // @level1type = N'Table',  @level1name = 'table_name';
        if (tableDescription) {
            const defaultSchemeName = 'dbo';

            let commentDefinition = '';
            commentDefinition += `@name = N'Table_Description',`;
            commentDefinition += `\n@value = '${formatComment(tableDescription)}',`;
            commentDefinition += `\n@level0type = N'Schema', @level0name = '${defaultSchemeName}',`;
            commentDefinition += `\n@level1type = N'Table',  @level1name = '${tableName}';`;

            commentDefinition += `${goCode}`;
            commentDefinition += `\n`;

            commentsDefinitions.push(commentDefinition);

            commentsDefinitionsByTables[tableName] = commentsDefinitions;
        }
        // ------------ COMMENTS: COLUMNS ------------
        // EXEC sp_addextendedproperty
        // @name = N'Column_Description',
        // @value = 'new column comment',
        // @level0type = N'Schema', @level0name = 'scheme_name',  -- by default scheme = 'dbo' (Database Owner)
        // @level1type = N'Table',  @level1name = 'table_name',
        // @level2type = N'Column', @level2name = 'column_name';

        if (comments.length) {
            comments.forEach((comment, i) => {
                const { tableName, columnName, description } = comment;

                const defaultSchemeName = 'dbo';

                let commentDefinition = '';
                commentDefinition += `@name = N'Column_Description',`;
                commentDefinition += `\n@value = '${formatComment(description)}',`;
                commentDefinition += `\n@level0type = N'Schema', @level0name = '${defaultSchemeName}',`;
                commentDefinition += `\n@level1type = N'Table',  @level1name = '${tableName}',`;
                commentDefinition += `\n@level2type = N'Column', @level2name = '${columnName}';`;

                commentDefinition += `${goCode}`;

                commentsDefinitions.push(commentDefinition);
            });

            commentsDefinitionsByTables[tableName] = commentsDefinitions;
        }

        // ------------ ENUMS /TYPES ------------
        // використання VARRAY або NESTED TABLE
        // CREATE OR REPLACE TYPE gender_enum_array AS VARRAY(2) OF VARCHAR2(10);
        // CREATE TYPE для створення користувацьких типів, таких як об'єкти або масиви.

        // ------------ FORMAT: CREATE TYPE gender_enum AS OBJECT (value VARCHAR2(10));
        // if (enums.length) {
        //     enums.forEach((enumItem, i) => {
        //         const { enumName, enumValuesString } = enumItem;

        //         let enumDefinition = `CREATE TYPE "${enumName}" AS ENUM (${enumValuesString})`;
        //         enumsDefinitions.push(enumDefinition);
        //     });

        //     enumsDefinitionsByTables[tableName] = enumsDefinitions;
        // }

        // ------------ ENUMS / CHECK ------------
        // ------------ `CONSTRAINT [check_name] CHECK ([column1] IN ('value1', 'value2'))`
        if (enums.length) {
            enums.forEach((enumItem, i) => {
                const { enumName, enumValuesString, columnName } = enumItem;
                const checkName = `chk_${enumName}`;

                let checkDefinitions = `CONSTRAINT ${formatColumnName(checkName)} CHECK (${formatColumnName(columnName)} IN (${enumValuesString}))`;
                checksDefinitions.push(checkDefinitions);
            });
        }

        // ------------ RESULT: INSIDE STATEMENTS ------------------------------------------------------------
        // ------------ CREATE TABLE: FINAL =====

        const isColumns = columnsDefinitions.length;
        const isPrimary = primaryKeysDefinitions.length;
        const isUnique = uniqueDefinitions.length;
        const isCheck = checksDefinitions.length;

        let createStatement = '';
        createStatement += `-- ---------- TABLE ${tableName.toUpperCase()} -----------\n`;
        // createStatement += `CREATE TABLE IF NOT EXISTS [${tableName}] (`;
        createStatement += `CREATE TABLE ${formatColumnName(tableName)} (`;

        if (isColumns) {
            createStatement += `\n  ${columnsDefinitions.join(',\n  ')}${isPrimary || isUnique || isCheck ? ',\n  ' : ''}`;
        }

        if (isPrimary && isUnique) {
            // createStatement += '  -- PRIMARY / UNIQUE';
            createStatement += `\n  ${[...primaryKeysDefinitions, ...uniqueDefinitions].join(',\n  ')}`; //${isCheck ? ',\n  ' : ''}`;
        } else if (isPrimary) {
            // createStatement += '  -- PRIMARY';
            createStatement += `\n  ${primaryKeysDefinitions.join(',\n  ')}`; //${isCheck ? ',\n  ' : ''}`;
        } else if (isUnique) {
            // createStatement += '  -- UNIQUE';
            createStatement += `\n  ${uniqueDefinitions.join(',\n  ')}`; //${isCheck ? ',\n  ' : ''}`;
        }

        if (isCheck) {
            // createStatement += '  -- CHECK';
            createStatement += `\n  ${checksDefinitions.join(',\n  ')}`;
        }
        createStatement += `\n);`;

        createStatement += goCode;

        tablesStatements.push(createStatement);
    }

    // ------------ COMMENTS: FINAL ------------
    const commentsKeys = Object.keys(commentsDefinitionsByTables);
    if (commentsKeys.length) {
        let commentStatements = [];
        const commentsHeaderStatement = "-- ---------- COMMENTS ---------------";
        commentStatements.push(commentsHeaderStatement);

        commentsKeys.forEach(commentKey => {
            const commentsDefs = commentsDefinitionsByTables[commentKey];
            commentStatements.push(commentsDefs.join('\n'));
        });
        tablesStatements.push(commentStatements.join('\n'));
    }

    // ------------ RESULT: OUTSIDE STATEMENTS ------------------------------------------------
    // ------------ ENUMS: FINAL ------------
    const enumsKeys = Object.keys(enumsDefinitionsByTables);
    if (enumsKeys.length) {
        const enumsHeaderStatement = "-- ---------- ENUMS ----------------";
        enumsStatements.push(enumsHeaderStatement);

        enumsKeys.forEach(enumKey => {
            const enumsDefs = enumsDefinitionsByTables[enumKey];
            enumsStatements.push(enumsDefs.join('\n'));
        });
    }

    // ------------ INDEXES: FINAL ------------
    const indexesKeys = Object.keys(indexesDefinitionsByTables);
    if (indexesKeys.length) {
        let indexStatements = [];
        const indexesHeaderStatement = "-- ---------- INDEXES ----------------";
        indexStatements.push(indexesHeaderStatement);

        indexesKeys.forEach(indexKey => {
            const indexesDefs = indexesDefinitionsByTables[indexKey];
            indexStatements.push(indexesDefs.join('\n'));
        });
        tablesStatements.push(indexStatements.join('\n'));
    }

    // ------------ FOREIGN KEYS: FINAL ------------
    const fkKeys = Object.keys(foreignKeysDefinitionsByTables);
    if (fkKeys.length) {
        let fkStatements = [];
        const fkHeaderStatement = "-- ---------- FOREIGN KEYS -----------";
        fkStatements.push(fkHeaderStatement);

        fkKeys.forEach(fkKey => {
            const fkDefs = foreignKeysDefinitionsByTables[fkKey];
            fkStatements.push(fkDefs.join('\n'));
        });
        tablesStatements.push(fkStatements.join('\n'));
    }

    let result = [];
    result.push(...statements);
    if (enumsStatements.length) {
        result.push(enumsStatements.join('\n'));
    }
    result.push(...tablesStatements);

    return result.join('\n\n');
    // return [...statements, ...enumsStatements, ...tablesStatements].join('\n\n') + '\n';
}
